import videojs from 'video.js';

import HelpIcon from '../../assets/images/help-white-24dp.svg';
import { isPresentationId } from '../../util';

const _url = new WeakMap();
const _enabled = new WeakMap();
let localize;

/**
 * The Help module.
 * @member {HelpPlugin} help
 * @memberof MediasitePlayer#
 */

/**
 * Configures the Help button that is displayed in the controlbar menu.
 * @hideconstructor
 * @extends {external:"videojs.Plugin"}
 */
class HelpPlugin extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        localize = player.localize?.bind(player);
        super(player, options);
        _enabled.set(this, true);

        player.ready(() => {
            player.controlbarMenu().addMenuItem(localize('Help'), { id: this.name, icon: HelpIcon, callback: () => this.handleClick() });
            player.controlbarMenu().disableMenuItem(this.name);
        });
    }

    handleClick() {
        if (isPresentationId(this.player.loader().presentationId) && this.enabled) {
            window.open(_url.get(this));
        }
    }

    /**
     * The URL that will be opened in a new window when the user clicks on the Help button.
     * @type {string}
     * @example
     * player.help.url = 'https://mediasite.com';
     */
    get url() {
        return _url.get(this);
    }

    set url(url) {
        _url.set(this, url);
        this.#updateVisibility();
    }

    /**
     * A boolean indicating whether or not the Help UI is enabled.
     * @type {boolean}
     * @example
     * player.help.enabled = true;
     */
    get enabled() {
        return _enabled.get(this);
    }

    set enabled(enabled) {
        _enabled.set(this, enabled);
        this.#updateVisibility();
    }

    #updateVisibility() {
        if (this.enabled && this.url) {
            this.player.controlbarMenu().enableMenuItem(this.name);
        }
        else {
            this.player.controlbarMenu().disableMenuItem(this.name);
        }
    }

    dispose() {
        if (this.player?.usingPlugin('controlbarMenu')) {
            this.player.controlbarMenu().removeMenuItem(this.name);
        }

        super.dispose();
    }
}

export default HelpPlugin;
